import React, { useContext, useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import {
  Toolbar,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  ToolbarGroup,
  Image,
  Avatar,
  Tooltip,
} from "@fluentui/react-components";
import { ArrowExitRegular, SettingsRegular, ArrowClockwiseRegular, DividerTallRegular } from "@fluentui/react-icons";
import { AppContext } from "./context/AppContext";
import { useNavigate } from "react-router-dom";
import { removeUserPreference } from "../../utils/storagehelper";
import { useHeaderStyles } from "./style/header.style";
import { reCalculate } from "../../utils/officedocumenthelper";
import { isValidUser } from "../../utils/common";
import { setActiveSheetState, getActiveSheetState } from "../../utils/sheetoptions";
const Header = () => {
  const styles = useHeaderStyles();
  const auth = useAuth();
  const context = useContext(AppContext);
  const navigate = useNavigate();
  const [sheetoptions, setSheetOptions] = useState({ sheetState: true, BatchCount: 0, CompletedBatchCount: 0 });
  const initialize = async () => {
    const option = await getActiveSheetState();

    if (option) {
      setSheetOptions(option);
      if (!option.sheetState || option.BatchCount > 0) getBatchCount();
    }
  };

  const logout = () => {
    if (isValidUser()) {
      navigate("/home");
    } else {
      void auth.removeUser().finally(() => {
        auth.clearStaleState();
        removeUserPreference();
      });
    }
  };

  const getBatchCount = async () => {
    const option = await getActiveSheetState();
    if (option.CompletedBatchCount < option.BatchCount) {
      setSheetOptions(option);
      window.setTimeout(() => {
        getBatchCount();
      }, 2000);
    } else {
      setSheetOptions({ ...option, sheetState: true, BatchCount: 0, CompletedBatchCount: 0 });
      setActiveSheetState({ ...option, sheetState: true, BatchCount: 0, CompletedBatchCount: 0 });
    }
  };

  const calculate = async () => {
    reCalculate();
    setSheetOptions({ ...sheetoptions, sheetState: false, BatchCount: 0, CompletedBatchCount: 0 });
    setActiveSheetState({ ...sheetoptions, sheetState: false, BatchCount: 0, CompletedBatchCount: 0 });
    window.setTimeout(() => {
      getBatchCount();
    }, 1500);
  };

  const handleSheetChanged = async (_e) => {
    initialize();
  };
  useEffect(() => {
    Excel.run(async (context) => {
      const worksheets = context.workbook.worksheets;
      worksheets.onActivated.add(handleSheetChanged);
      await context.sync();
      return () => {
        worksheets.onActivated.remove(handleSheetChanged);
      };
    });
  }, []);

  useEffect(() => {
    initialize();
  }, [context.isSheetAddedOrRemoved]);

  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in...</div>;
    case "signoutRedirect":
      return <div>Signing you out...</div>;
  }

  return (
    <Toolbar className={styles.toolbar}>
      <ToolbarGroup>
        <div>
          <div>
            <Image
              alt="MSCI Inc."
              // src="https://qa-privatei.burgiss.co/Resources/css/images/MSCI_Logo_2019_White.svg"
              src="./assets/MSCI_Logo_2019_White.svg"
              width={90}
            />
          </div>
          <div
            style={{
              gap: "5px",
            }}
            className={styles.toolbar_icon_container}
          >
            {context.selectedProfile && (
              <>
                {!sheetoptions.sheetState ? (
                  <div>
                    <div>
                      {sheetoptions.CompletedBatchCount}/{sheetoptions.BatchCount}
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
                {sheetoptions.sheetState ? (
                  <Tooltip content="Recalculate" relationship="label">
                    <ArrowClockwiseRegular
                      id="Recalculateicon"
                      className={styles.icon24}
                      onClick={() => calculate()}
                    ></ArrowClockwiseRegular>
                  </Tooltip>
                ) : (
                  <Tooltip content="Calculating" relationship="label">
                    <ArrowClockwiseRegular id="Recalculateicon" className={styles.icon25}></ArrowClockwiseRegular>
                  </Tooltip>
                )}
                <DividerTallRegular fontSize={24}></DividerTallRegular>
              </>
            )}
            <Avatar size={24} name={auth.user.profile.name}></Avatar>
            {context.selectedProfile && (
              <Menu>
                <MenuTrigger>
                  <SettingsRegular className={styles.icon24}></SettingsRegular>
                </MenuTrigger>
                <MenuPopover>
                  <MenuList>
                    <MenuItem onClick={() => navigate("/sheetoption")}>Sheet Options</MenuItem>
                    <MenuItem onClick={() => navigate("/errorhandling")}>Error Handling</MenuItem>
                    <MenuItem onClick={() => window.open("https://prod-excel-privatei.burgiss.com/excel/MSCI%20Private%20i%20Platform%20Excel%20Add-in%20Reference%20Guide.pdf", "_blank")}>
                      Help
                    </MenuItem>
                  </MenuList>
                </MenuPopover>
              </Menu>
            )}
            <Tooltip content="Logout" relationship="label">
              <ArrowExitRegular className={styles.icon24} onClick={() => logout()}></ArrowExitRegular>
            </Tooltip>
          </div>
        </div>
      </ToolbarGroup>
    </Toolbar>
  );
};
export default Header;
